var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("404 Not Found")]),_c('hr'),_c('div',{staticClass:"nginx"},[_vm._v("nginx")])])])
}]

export { render, staticRenderFns }